module.exports = __webpack_public_path__ + "static/media/dropper.dbdc7660.svg";